import { useParams, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useRef, useState, memo } from 'react';
import { getDate } from "../../../hooks/useCurrentDate";
import {
    IconNavbarButtonBg,
    //IconProgress,
    IconUser,
    IconUserImages,
    IconUserChristmasImages
} from "../../elements/Icon";

import {
    updateSelectedProfile,
    updateProfileThunk,
    fetchProfilesThunk
} from '../../../redux/features/userSlice';

import {
    getTotalScoreThunkWithoutSub
} from '../../../redux/features/gamesSlice';


import { styles, cmpStyles, cmps, elems, langs, colors, plainStyles } from "./assets/constants";
import useOutsideAlerter from "../../../hooks/useOutsideAlerter.jsx";
import { checkChristmas } from "../../../hooks/useCheckChristmas";
import Sound from "../Sound";
import { isProd, API_URL } from "../../../config";
import { LeftBar } from "../LeftBar";
import { resetUser, logOutUserThunk } from "../../../redux/features/userSlice";
import { useDragControls } from "framer-motion";

const getLang = (name) => {
    const index = name.indexOf('-');
    return index === -1 ? name : name.slice(0, index);
};



export default memo(function Navbar({
    handleOpen,
    handleSound,
    screenSize = window.innerWidth,
    subscription,
    // handleResult,
    cmp,
    handleOpenAvatar,
    handleBackgroundMusic,
    point,
    sound,
    refresh,
    backgroundMusic,
    topButtonRef,
    handleStrike,
    handleGift,
    onClick,
    days,
    giftRef,
    countStrike
}) {
    localStorage.getItem('lang') && localStorage.removeItem('lang');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    let { name, gameName } = useParams();
    if (!name) name = localStorage.getItem('name')
    const { pathname } = useLocation();
    const location = useLocation();
    const { t, i18n } = useTranslation();
    const [lang, setLang] = useState(getLang(localStorage.getItem('i18nextLng')) || 'en');
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(screenSize.width >= 1024 ? 1 : 0);
    const user = useSelector((state) => state.user);
    const selectedProfile = useSelector(
        state => state.user.selectedProfile
    );
    const profiles = useSelector(state => state.user.profiles);

    const [showLeftBar, setShowLeftBar] = useState(false);
    const [userSettings, setUserSettings] = useState(false);
    const deviceToken = user.user?.userEmail || null
    const handleLanguage = (name, i) => {
        i18n.changeLanguage(name);
        setLang(getLang(name));
        const item = document.querySelectorAll('.langItem');
        item.forEach((item, pos) => {
            if (i === pos) {
                item.classList.remove('after:scale-x-0');
                item.classList.add('after:scale-x-100');
            } else {
                item.classList.remove('after:scale-x-100');
                item.classList.add('after:scale-x-0');
            }
        });
        setTimeout(() => setOpen(false), 1000);
    }
    const userSetRef = useRef(null);
    const userSetRefIcon = useRef(null);
    const wrapperRef = useRef(null);
    const strike = countStrike || localStorage.getItem('streak');
    useOutsideAlerter(wrapperRef, () => {
        setShowLeftBar(false);
    });

    useEffect(() => {
        if (!selectedProfile && profiles && profiles.length > 0) {
            const fullProfile = profiles[0];
            dispatch(updateSelectedProfile(fullProfile));
            localStorage.setItem('profile', JSON.stringify(fullProfile));
        }
    }, [selectedProfile, profiles, dispatch]);



    useEffect(() => {
        if (!profiles.length) {
            dispatch(updateSelectedProfile(null));
            localStorage.removeItem('profile');
            return;
        }

        const stored = localStorage.getItem('profile');
        const storedProfile = stored ? JSON.parse(stored) : null;

        const exists = profiles.find(p => p._id === storedProfile?._id);

        if (exists) {
            dispatch(updateSelectedProfile(exists));
        } else {
            dispatch(updateSelectedProfile(profiles[0]));
            localStorage.setItem('profile', JSON.stringify(profiles[0]));
        }
    }, [profiles, dispatch]);

    useEffect(() => {
        setIndex(screenSize.width >= 1024 ? 1 : 0);
    }, [screenSize.width]);

    useEffect(() => {
        const savedProfile = JSON.parse(localStorage.getItem("profile"));
        if (savedProfile) {
            const profileFromProfiles = profiles.find(p => p._id === savedProfile._id);
            if (profileFromProfiles) {
                dispatch(updateSelectedProfile(profileFromProfiles));
            } else {
                dispatch(updateSelectedProfile(savedProfile));
            }
        }
    }, [dispatch, profiles]);


    useEffect(() => {
        if (deviceToken) {
            dispatch(fetchProfilesThunk(deviceToken));
        }
    }, [dispatch, deviceToken]);

    useEffect(() => {
        if (selectedProfile?._id) {
            dispatch(getTotalScoreThunkWithoutSub({
                profileId: selectedProfile._id
            }));
        }
    }, [selectedProfile?._id]);


    useEffect(() => {
        if (name) {
            localStorage.setItem("name", name);
        }
    }, [name]);
    if (!name) name = "counting"

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                userSettings &&
                userSetRef.current &&
                userSetRefIcon.current &&
                !userSetRef.current.contains(e.target) &&
                !userSetRefIcon.current.contains(e.target)
            ) {
                setUserSettings(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [userSettings]);


    const storage = localStorage.getItem('scoreStorage');
    let count = 0;
    if (storage) {
        JSON.parse(storage).forEach((item) => {
            if (item.date === getDate()) {
                count = item.score
            }
        })
    }

    const leaderboardPath = (() => {
        if (location.pathname.startsWith("/games")) {
            if (name && gameName) {
                return `/games/${name}/${gameName}/leaderboard`;
            }

            if (name) {
                return `/games/${name}/leaderboard`;
            }
        }
        let nameFromStorage = localStorage.getItem("name")

        return `/games/${nameFromStorage}/leaderboard`;
    })();
    const gamePath = `/games/${name}/${gameName || ""}`;

    const gameresultPath = (() => {
        if (location.pathname.startsWith("/games")) {
            if (name && gameName) {
                return `/games/${name}/${gameName}/gameresult`;
            }

            if (name) {
                return `/games/${name}/gameresult`;
            }
        }
        let nameFromStorage = localStorage.getItem("name")

        return `/games/${nameFromStorage}/gameresult`;
    })();



    const handleSmallSize = (val) => {
        if (val) {
            setShowLeftBar(false);
            localStorage.setItem("leftBarIsOpen", JSON.stringify(false));
        } else {
            setShowLeftBar(!showLeftBar);
            localStorage.setItem("leftBarIsOpen", JSON.stringify(!showLeftBar));
        }
    }

    return (
        <div
            id="top"
            onClick={onClick}
            className={`z-50 relative h-[37px] md:h-[56px] sm:no-scrollbar lg:h-[54px] items-center xl:h-[80px] flex w-full bg-[#FCF9EE] px-4 shadow-[0px_2px_7px_0px_rgba(188,_188,_188,_0.22)]`}>
            <div className={`${(showLeftBar || localStorage.getItem("leftBarIsOpen") && JSON.parse(localStorage.getItem("leftBarIsOpen"))) && window.innerWidth < 1024 ? 'space-x-0' : 'lg:space-x-6 space-x-4'} flex w-[28%] h-[27px] md:h-[35px] lg:h-[40px] xl:h-[52px]`}>

                {elems.slice(index, 4).map((item) => {
                    const Component = cmps[item];

                    if (item === 'IconHome') {
                        return (
                            <NavLink
                                key={item}
                                to="/games/counting"
                                className={`${window.innerWidth < 1024 ? 'hidden' : 'block'} h-[27px] md:h-[36px]`}
                            >
                                <div className={styles.button}>
                                    <div className={cmpStyles[item]}>
                                        <Component className={styles.animation} />
                                    </div>
                                    <IconNavbarButtonBg className={styles.buttonBg} />
                                </div>
                            </NavLink>
                        );
                    }

                    return (
                        <button
                            key={item}
                            onClick={() => {
                                if (item === 'IconSettings') handleOpen();
                                if (item === 'IconLanguage') setOpen(!open);
                                if (item === 'MenuIconForSmallSize') handleSmallSize();
                            }}
                            className={styles.button}
                        >
                            <div className={cmpStyles[item]}>
                                <Component
                                    lang={lang.startsWith("ch") ? "ch" : lang}
                                    className={styles.animation}
                                />
                            </div>

                            <IconNavbarButtonBg
                                className={`${styles.buttonBg} ${item === "MenuIconForSmallSize" ? 'md:hidden' : ''}`}
                            />
                        </button>

                    );
                })}

                {open && <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />}

                {open && <div
                    className="lang z-[99] w-[151px] lg:pl-[28px] lg:pt-[17px] lg:mt-[60px] h-[210px] lg:w-[200px] lg:h-[253px] pl-[10px] pt-[9px] text-[12px] text-[#4F9686] mt-[40px] md:mt-[48px]  text-shadow-[0px_2px_5px_rgba(113,_113,_113,_0.25)] font-fredokaOne lg:text-[14px] xl:text-[18px] xl:pl-[18px] xl:pt-[17px] absolute overflow-y-scroll xl:mt-[76px] xl:w-[220px] xl:h-[281px] bg-[#FFFBED] rounded-[8px] shadow-[6px_14px_28px_0px_rgba(125,_125,_125,_0.25)]">
                    {Object.entries(langs).map(([key, value], i) => <div key={value}
                        className={`${value === lang ? 'after:scale-x-100' : 'after:scale-x-0'} langItem w-[80px] lg:w-[100px] w-full pb-[5px] cursor-pointer whitespace-nowrap`}
                        onClick={() => handleLanguage(value, i)}>{key}</div>)}
                </div>}
                {screenSize.width < 1024 && <LeftBar handleOpen={() => handleSmallSize(true)} cmp={"navbar"} openSmallSize={showLeftBar} />}
            </div>
            <span
                style={{ color: cmp ? colors[cmp] : colors.shapes }}
                className={`${cmp ? 'font-chango' : 'font-fredokaOne'} text-center text-[14px] md:text-[20px] lg:text-[24px] xl:text-[32px] flex-1`}>
                {/* {name.toUpperCase()} */}

                <>
                    {pathname === '/about'
                        ? t(`aboutUs`)
                        : (pathname === '/registration' || pathname === '/')
                            ? ''
                            : t(`${name}`)
                    }
                    {!isProd ? ` ${window.innerWidth}x${window.innerHeight}` : ""}
                </>
            </span>
            <div className="flex lg:space-x-6 space-x-4 justify-end items-center w-[28%]">
                {elems.slice(4).map((item) => {
                    const Component = cmps[item];
                    if (pathname === '/registration' && ['IconStar', 'IconFire', 'IconGift'].includes(item)) {
                        return null;
                    }
                    if (item === 'IconStar') {
                        return (
                            <button
                                key={item}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(
                                        location.pathname === gameresultPath
                                            ? gamePath
                                            : gameresultPath
                                    );
                                }}
                                className={plainStyles.button}
                            >
                                <Component className="w-[18px] md:w-[22px] lg:w-[26px] text-[#FFD670]" />
                            </button>
                        );
                    }

                    if (item === 'IconTop') {
                        return (
                            <button
                                key={item}
                                ref={topButtonRef}
                                onClick={() =>
                                    navigate(
                                        location.pathname === leaderboardPath
                                            ? gamePath
                                            : leaderboardPath
                                    )
                                }
                                className={plainStyles.button}
                            >
                                <Component className="w-[18px] md:w-[22px] lg:w-[26px] text-[#FFD670]" />
                            </button>
                        );
                    }

                    if (item === 'IconFire' || item === 'IconGift') {
                        return (
                            <div key={item} ref={item === 'IconGift' ? giftRef : null}>
                                <button
                                    className={plainStyles.button}
                                    onClick={() => {
                                        if (item === 'IconFire') handleStrike();
                                        if (item === 'IconGift' && days > 0) handleGift();
                                    }}
                                >
                                    {item === 'IconFire' && <span
                                        className={`absolute -top-1 -right-1 bg-[#F15A29] text-white font-bold
                         rounded-full
                        w-3 h-3 md:w-4 md:h-4 xl:w-5 xl:h-5
                        flex items-center justify-center border border-color-[#FCF9EE]
                        ${strike <10 
                                                ? "text-[10px] md:text-[12px] lg:text-[14px] xl:text-[16px]"
                                                : strike > 9
                                                    ? "text-[8px] md:text-[10px] lg:text-[12px] xl:text-[14px]"
                                                    : "text-[6px] md:text-[8px] lg:text-[10px] xl:text-[12px]"
                                            }`

                                        }
                                    >
                                        {strike}
                                    </span>}
                                    {item === 'IconGift' && (
                                        <span
                                            className={`
                                                     absolute -top-1 -right-2
                                                     bg-[#F15A29] text-white font-bold rounded-full
                                                     flex items-center justify-center
                                                     border border-[#FCF9EE]
                                                     w-3 h-3 md:w-4 md:h-4 xl:w-5 xl:h-5

                                                    ${days.toString().length === 1
                                                    ? "text-[10px] md:text-[12px] lg:text-[14px] xl:text-[16px]"
                                                    : days.toString().length === 2
                                                        ? "text-[8px] md:text-[10px] lg:text-[12px] xl:text-[14px]"
                                                        : "text-[6px] md:text-[8px] lg:text-[10px] xl:text-[12px]"
                                                } `}
                                        >
                                            {days}
                                        </span>
                                    )}

                                    <Component className="w-[18px] md:w-[22px] lg:w-[26px] text-[#FFD670]" />
                                </button>
                            </div>
                        );
                    }

                    return (
                        <NavLink
                            key={item}
                            to={`/games/${name}/${gameName || ""}`}
                            className="flex items-center justify-center h-[27px] md:h-[36px]"
                        >
                            <div className={plainStyles.button}>
                                <Component className="w-[18px] md:w-[22px] lg:w-[26px] text-[#FFD670]" />
                            </div>
                        </NavLink>
                    );
                })}



                <div className={`relative ${selectedProfile ? 'h-[36px] md:h-[50px]' : 'h-[27px] md:h-[36px]'}`}>
                    {!selectedProfile &&
                        <div
                            ref={userSetRefIcon}
                            className="flex items-center space-x-2 relative flex items-center justify-center w-full h-full">
                            <button className={`${styles.button} relative flex items-center justify-center w-full h-full`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setUserSettings(!userSettings);
                                }}
                            >
                                <div className={cmpStyles.IconUser}>
                                    <IconUser className={`${styles.animation}`} />
                                </div>
                                <IconNavbarButtonBg className={`${styles.buttonBg}`} />
                            </button>
                        </div>
                    }


                    {selectedProfile && (
                        <div
                            ref={userSetRefIcon}
                            className="flex items-center space-x-2 relative flex items-center justify-center w-full h-full">
                            <div className="h-[40px] flex items-center justify-center px-2 bg-[#FFFBED] rounded-[6px] max-w-[90px]">
                                <span className="truncate text-[12px] md:text-[14px] text-black font-bold">
                                    {selectedProfile?.nickName
                                        ? selectedProfile.nickName.charAt(0).toUpperCase() + selectedProfile.nickName.slice(1)
                                        : 'Profile'}
                                </span>
                            </div>


                            <div
                                onClick={(e) => {
                                    e.preventDefault();
                                    setUserSettings(!userSettings);
                                }}
                                className="cursor-pointer ml-[5px] group relative text-center overflow-hidden w-[33px] h-[33px] md:w-[50px] md:h-[50px] lg:w-[52px] lg:h-[52x] xl:w-[67px] xl:h-[70px] rounded-[50%] border-[1px] md:border-[3px] border-[#418777] bg-[#F6F6F6]"
                            >
                                {checkChristmas() ? <IconUserChristmasImages
                                    user={selectedProfile?.avatar}
                                //className={` absolute w-[35px] md:w-[50px] xl:w-[65px] h-[100px] xl:h-[150px] top-[-10%] sm:top-[-20%] md:top-[-30%] lg:top-[-40%] xl:top-[-55%] left-[-3px] xl:left-[-5px]`}
                                /> : <IconUserImages
                                    user={selectedProfile?.avatar}
                                //className={` absolute w-[35px] md:w-[50px] xl:w-[65px] h-[100px] xl:h-[150px] top-[-90%] sm:top-[-80%] md:top-[-70%] lg:top-[-60%] xl:top-[-55%]left-[-3px] xl:left-[-5px]`}
                                />}
                            </div>
                        </div>
                    )}
                    {userSettings && <div
                        ref={userSetRef}
                        className={`font-fredokaOne z-[100] text-[#4F9686] flex flex-col right-[0%] absolute
                         xl:text-[20px] xl:w-[215px] xl:h-[186px] xl:leading-[22px]
                         lg:text-[16px] lg:w-[171px] lg:h-[162px] lg:leading-[20px]
                         md:text-[14px] md:w-[152px] md:h-[150px] md:leading-[22px]
                         text-[14px] w-[152px] h-[138px] sm:leading-[22px]
                         bg-[#FFFBED] rounded-[8px] shadow-[6px_14px_28px_0px_rgba(125,_125,_125,_0.25)]
                         ${selectedProfile
                                ? 'xl:top-[135%] md:top-[110%] lg:top-[110%] top-[107%]'
                                : 'top-full xl:mt-7 lg:mt-3 md:mt-3 mt-2'
                            }`}
                    >
                        {!deviceToken &&
                            <>
                                <NavLink className="xl:p-[20px]  lg:p-[16px] md:p-[14px] p-[12px]" to='/registration' onClick={() => setUserSettings(false)}>{t("logIn")}</NavLink>
                                <hr
                                    style={{ border: "1px solid #BFD3C7" }}
                                    className="w-full"
                                />
                            </>
                        }

                        <div
                            className="cursor-pointer xl:p-[20px] lg:p-[16px] md:p-[14px] p-[12px]"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleOpenAvatar();
                                setUserSettings(false);
                            }}
                        >
                            {t("profiles")}
                        </div>
                        <hr
                            style={{ border: "1px solid #BFD3C7" }}
                            className="w-full"
                        />


                        <NavLink className="xl:p-[20px] lg:p-[16px] md:p-[14px] p-[12px]" to='/about' onClick={() => setUserSettings(false)}>{t("aboutUs")}</NavLink>



                        {deviceToken &&
                            <>
                                <hr
                                    style={{ border: "1px solid #BFD3C7" }}
                                    className="w-full"
                                />
                                <div
                                    className="cursor-pointer  xl:p-[20px]  lg:p-[16px] md:p-[14px] p-[12px]"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (user.login) {
                                            dispatch(logOutUserThunk());
                                            dispatch(resetUser());
                                            localStorage.removeItem("user");
                                            localStorage.removeItem('avatar');
                                            //handleOpenAvatar();
                                            setUserSettings(!userSettings);

                                            navigate('/registration', { state: 'login' });
                                        }
                                    }}
                                >
                                    {t("logOut")}
                                </div> </>}

                    </div>}
                </div>
            </div>
        </div>
    );
})
